// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCheckbox-StyledFormField_cls1__xTKz8","cls2":"VeloCheckbox-StyledFormField_cls2__fDxI+ VeloCheckbox-StyledFormField_cls1__xTKz8"};